@if (validationSummary) {
    <div
        id="form-validation-summary"
        class="alert alert-danger mx-2 mb-2"
        role="alert"
        tabindex="-1"
        [innerHTML]="validationSummary">
    </div>
}

<div>
    <button
        (click)="submit()"
        class="btn mx-2"
        [ngClass]="buttonClasses"
        [disabled]="isButtonDisabled"
        [attr.aria-describedby]="validationSummary ? 'form-validation-summary' : null"
    >
        <i
            class="fa mx-2"
            [ngClass]="iconClasses"
            aria-hidden="true"
        ></i>
        <span [innerHTML]="buttonLabel"></span>

        @if (showRepeatActionLabel) {
            <span>{{ repeatActionLabel }}</span>
        }
    </button>
</div>
